import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__title" }
const _hoisted_3 = { class: "header__notification --refresh" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "refresh", -1)
const _hoisted_5 = { class: "header__notification --error" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "error_outline", -1)
const _hoisted_7 = { class: "header__navigation" }
const _hoisted_8 = { class: "header__navigation__entry" }
const _hoisted_9 = {
  key: 0,
  class: "header__navigation__submenu"
}
const _hoisted_10 = { class: "header__navigation__label" }
const _hoisted_11 = { class: "header__navigation__submenu__entry" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ThemeSwitch = _resolveComponent("ThemeSwitch")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentRouteName), 1),
    _createVNode(_Transition, { name: "notification" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" Updating data ")
        ], 512), [
          [_vShow, _ctx.buildingData]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "notification" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" Websocket connection error ")
        ], 512), [
          [_vShow, _ctx.connectionError]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuEntries, (entry, name) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (entry.submenu)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(entry.label), 1),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.submenu, (submenuEntry) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      tag: "a",
                      class: "header__navigation__label",
                      href: submenuEntry.url || '',
                      to: submenuEntry.url || ''
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(submenuEntry.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "to"]))
                  }), 256))
                ])
              ]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                tag: "a",
                class: "header__navigation__label",
                href: entry.url || '',
                to: entry.url || ''
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(entry.label), 1)
                ]),
                _: 2
              }, 1032, ["href", "to"]))
        ]))
      }), 256))
    ]),
    _createVNode(_component_ThemeSwitch)
  ]))
}